export default __webpack_public_path__ + "7cbb59b606e8155b4c6df1634585e9fa.png";